/**
 * Copyright 2024 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */

const defaultDiscoveryUri = 'https://pcast.phenixrts.com/pcast/endPoints';

export {defaultDiscoveryUri};